<template>
  <div>
    <img src="static/assets/images/132.jpg" style="width: 100%;height: 600px;"/>
    <div class="page-title text-center">
      <div class="container">
        <div class="row">
<!--          <div class="col-md-7 offset-md-5" style="top: -195px;">-->
<!--            <h1 style="color:#333">灵活用工及薪酬结算平台</h1>-->
<!--&lt;!&ndash;            <button type="submit" class="template-btn" style="background: rgb(160,156,156,0.5);border: none;border-radius: 22px;">1对1提供咨询</button>&ndash;&gt;-->
<!--&lt;!&ndash;            <button type="submit" class="template-btn" style="background: rgb(160,156,156,0.5);border: none;border-radius: 22px;">7*24免费服务</button>&ndash;&gt;-->

<!--&lt;!&ndash;            <p style="color: #fff">企业灵活用工实现费用结算和规划，提供效率&ndash;&gt;-->
<!--&lt;!&ndash;              解决企业支出成本问题，减少支出</p>&ndash;&gt;-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>产品优势</h2>
<!--              <p>Open lesser winged midst wherein may morning</p>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="single-feature mb-4 mb-lg-0">
              <h4 style="text-align: center">用工风险转移</h4>
              <p class="py-3">
                签订服务项目总包合同，与自由职业者之间不再有直接业务关系，风险大大被降低。</p>
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
          <div class="col-lg-4">
            <div class="single-feature mb-4 mb-lg-0">
              <h4 style="text-align: center">税务风险转移</h4>
              <p class="py-3">
                签订服务项目总包合同，由平台承担自由职业者相关纳税义务，税务风险被转移。</p>
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
          <div class="col-lg-4">
            <div class="single-feature">
              <h4 style="text-align: center">用工成本降低</h4>
              <p class="py-3">
                大部分纳税成本包含在服务费中，间接享受部分地区独有的税收优惠政策。</p>
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->


    <!-- Team Area Starts -->
    <section class="team-area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>业务模式</h2>
              <p>利用互联网SAAS数字化和智能化，解决企业佣金代发报税、保险、金融等难题，实现企业、自由职业者和社会的三方共赢</p>
            </div>
          </div>
        </div>
        <div class="row">
          <img src="static/assets/images/112.png" alt="" style="width: -webkit-fill-available;">
<!--          <div class="col-lg-3 col-sm-6">-->
<!--            <div class="single-team mb-5 mb-lg-0">-->
<!--              <div class="team-img team-img1">-->
<!--                <div class="hover-state">-->
<!--                  <ul>-->
<!--                    <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-linkedin"></i></a></li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="team-footer text-center mt-4">-->
<!--                <h3>ethel davis</h3>-->
<!--                <h5>managing director (sales)</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-3 col-sm-6">-->
<!--            <div class="single-team mb-5 mb-lg-0">-->
<!--              <div class="team-img team-img2">-->
<!--                <div class="hover-state">-->
<!--                  <ul>-->
<!--                    <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-linkedin"></i></a></li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="team-footer text-center mt-4">-->
<!--                <h3>rodney cooper</h3>-->
<!--                <h5>creative art director (project)</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-3 col-sm-6">-->
<!--            <div class="single-team mb-5 mb-sm-0">-->
<!--              <div class="team-img team-img3">-->
<!--                <div class="hover-state">-->
<!--                  <ul>-->
<!--                    <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-linkedin"></i></a></li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="team-footer text-center mt-4">-->
<!--                <h3>dora walker</h3>-->
<!--                <h5>senior core developer</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-3 col-sm-6">-->
<!--            <div class="single-team">-->
<!--              <div class="team-img team-img4">-->
<!--                <div class="hover-state">-->
<!--                  <ul>-->
<!--                    <li><a href="#"><i class="fa fa-facebook"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>-->
<!--                    <li><a href="#"><i class="fa fa-linkedin"></i></a></li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="team-footer text-center mt-4">-->
<!--                <h3>lena keller</h3>-->
<!--                <h5>creative content developer</h5>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </section>
    <!-- Team Area End -->

    <!-- Employee Area Starts -->
<!--    <section class="employee-area section-padding">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Happy employee</h2>-->
<!--              <p>Open lesser winged midst wherein may morning</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="employee-slider owl-carousel">-->
<!--              <div class="single-slide d-sm-flex">-->
<!--                <div class="slide-img employee1">-->
<!--                  <div class="hover-state">-->
<!--                    <div class="hover-text text-center">-->
<!--                      <h3>david aron</h3>-->
<!--                      <h5>Facebook</h5>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="slide-text align-self-center">-->
<!--                  <i class="fa fa-quote-left"></i>-->
<!--                  <p>-->
<!--                    Appear, called day. Sixth two after eve moved called winged very heaven two lights let all third gathered.</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="single-slide d-sm-flex">-->
<!--                <div class="slide-img employee2">-->
<!--                  <div class="hover-state">-->
<!--                    <div class="hover-text text-center">-->
<!--                      <h3>david aron</h3>-->
<!--                      <h5>Twitter</h5>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="slide-text align-self-center">-->
<!--                  <i class="fa fa-quote-left"></i>-->
<!--                  <p>-->
<!--                    Appear, called day. Sixth two after eve moved called winged very heaven two lights let all third gathered.</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- Employee Area End -->
  </div>
</template>

<script>
  export default {}

</script>




// WEBPACK FOOTER //
// src/pages/About.vue